import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SharedDataService } from '../../services/shared-data.service';
import { AuthPolicies } from '../../auth/auth-policies';

@Component({
  selector: 'app-shop-contract',
  standalone: true,
  templateUrl: './shop-contract.component.html',
  styleUrls: ['./shop-contract.component.scss'],
  imports: [CommonModule, RouterLink, RouterOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShopContractComponent implements OnInit, OnDestroy {
  public currentIndex$ = new BehaviorSubject<number>(0);

  // Pagination state
  totalRecords = 500; // you can update this dynamically
  pageSize = 20;
  currentPage = 1;

  get showOemDiscountBreadcrumb(): boolean {
    const url = this.router.url.split('?')[0].split('#')[0];
    return /\/oem-discount\/[^/]+/.test(url);
  }

  get oemDiscountBreadcrumbLabel(): string {
    const url = this.router.url.split('?')[0].split('#')[0];
    if (url.endsWith('/add-new')) {
      return 'Add New';
    }
    if (url.endsWith('/edit')) {
      return 'Edit';
    }
    return decodeURIComponent(url.split('/').pop() ?? '');
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedDataService: SharedDataService,
    public readonly authPolicies: AuthPolicies,
  ) {}

  ngOnInit(): void {
    const currentUrl = this.router.url;
    if (currentUrl.endsWith('/shop-contract') || currentUrl.endsWith('/shop-contract/')) {
      this.router.navigate(['material-rates'], { relativeTo: this.route });
    }

    this.currentIndex$ = new BehaviorSubject(this.getTabIndexFromUrl());
    this.route.url.subscribe(() => {
      this.currentIndex$?.next(this.getTabIndexFromUrl());
    });
  }

  ngOnDestroy(): void {
    // Clear all tab filters when navigating away from shop-contract screen
    this.sharedDataService.setLabourRatesFilterFormValue(null);
    this.sharedDataService.setMaterialRateFilterFormValue(null);
  }

  private getTabIndexFromUrl(): number {
    const url = window.location.pathname;
    if (url.includes('material-rates')) return 0;
    if (url.includes('labour-rates')) return 1;
    if (url.includes('oem-discount')) return 2;
    return 0;
  }
}
